var utils = require('../../utils')

export default {
  name: 'patient-list-report',
  data: function () {
    return {
      shopId:        null,
      facilityId:    null,
      patientData:   null,
      patientId:     null,
      prescribeDate: null,
      deliveryDate:  null,
      searchCallbackFlag: false,
      watchScroll: null,
      // ソート
      sortState: {
        'prescribe_date': {'state': false, 'order': false},
        'delivery_date' : {'state': true,  'order': false},
      },
      sortStateInit: {}
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    if (utils.isPresent(this) && '$store' in this) {
      if (this.$store.getters.reportListParams !== null) {
        this.$store.getters.reportListParams['pageYOffset'] = window.pageYOffset // スクロール位置保存
        this.$store.getters.reportListParams['scrollHeight'] = utils.getScrollHeight() // スクロール高さ保存
      }
      if (this.watchScroll !== null) {
        this.watchScroll.disconnect()
        this.watchScroll = null
      }
    }
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    next()
  },
  created: function () {
    var readMore = false

    // ソート初期化用保存
    for (var k in this.sortState) {
      this.sortStateInit[k] = {}
      this.sortStateInit[k].state = this.sortState[k].state
      this.sortStateInit[k].order = this.sortState[k].order
    }

    // this.$store.dispatch('SHOP_SEARCH')
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})

    this.facilityId = this.$router.currentRoute.params['facilityId']
    this.patientId  = this.$router.currentRoute.params['patientId']
    this.patientData = null
    if (this.$router.currentRoute.query.keep !== 'true') {
      this.$store.dispatch('PATIENT_SHOW_CLEAR')
      if (this.$store.getters.canManage) {
        this.shopId = this.$store.getters.currentShopId
      }
      this.clearSearchParams()
      // 前画面の検索結果に存在する場合
      if (this.patients) {
        for (var i = 0; i < this.patients.length; i++) {
          var d = this.patients
          if (d[i]['id'] === this.patientId && d[i].attributes['facility-id'] === this.facilityId) {
            this.patientData = d[i]
            break
          }
        }
      }
      if (this.patientData === null) {
        this.$store.dispatch('PATIENT_SHOW', {patientId: this.patientId})
      }
    } else {
      if (this.$store.getters.reportListParams) {
        this.shopId        = this.$store.getters.reportListParams['shop_id']
        this.prescribeDate = this.$store.getters.reportListParams['ggPrescribeDate']
        this.deliveryDate  = this.$store.getters.reportListParams['ggDeliveryDate']
        // ソートデータ
        var orderData = this.$store.getters.reportListParams['orderByStoreData']
        if (orderData && 'key' in orderData && 'key' in orderData && 'order' in orderData) {
          // 初期化
          for (var key in this.sortState) {
            this.sortState[key] = {'state': false, 'order': false}
          }
          // ストアから設定
          this.sortState[orderData.key] = {'state': true, 'order': orderData.order}
        }
        if (this.currentPage !== null && this.currentPage >= 1) {
          readMore = 'keepload'
        }
      }
      if (this.shopId === null) {
        this.shopId = this.$store.getters.currentShopId
      }
      if (this.patient === null) {
        this.$store.dispatch('PATIENT_SHOW', {patientId: this.patientId})
      }
    }
    this.search(readMore)

    // 最下部スクロールイベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  computed: {
    /** トークン */
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    /** 患者 */
    patient () {
      if (this.patientData) {
        return this.patientData
      } else {
        return this.$store.getters.patient
      }
    },
    /** 計画書 */
    reportList () {
      return this.$store.getters.reportList
    },
    /** 計画書次ページ */
    reportListNextPage () {
      return this.$store.getters.reportListNextPage
    },
    /** 計画書件数 */
    reportListTotalCount () {
      return this.$store.getters.reportListTotalCount
    },
    /** 計画書次リンク */
    reportListNextPageLink () {
      return this.$store.getters.reportListNextPageLink
    },
    /** データ存在確認用 */
    reportListExists () {
      return this.$store.getters.reportListExists
    },
    /** 検索パラメーター */
    reportListParams () {
      return this.$store.getters.reportListParams
    },
    /** 前画面データ */
    patients () {
      return this.$store.getters.patients
    },
    /** 通知 */
    notify () {
      if (this.$store.getters.reportEditNotify !== null) {
        return this.$store.getters.reportEditNotify
      }
      return this.$store.getters.reportNotify
    },
    currentPage () {
      return this.$store.getters.reportListCurrentPage
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  methods: {
    /** 計画書検索 */
    search: function (readMore) {
      var url = null
      var clear = true
      var loadparams = true
      var self = this

      if (readMore === 'sort') {
        // ソート読み込み
        clear       = false
        loadparams  = 'block'
      } else if (readMore === 'keepload') {
        // 再読込
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true

        // スクロール位置
        var pageYOffset = this.$store.getters.reportListParams['pageYOffset']
        var scrollHeight = this.$store.getters.reportListParams['scrollHeight']
        this.$store.getters.reportListParams['pageYOffset'] = null
        this.$store.getters.reportListParams['scrollHeight'] = null
        this.watchScroll = utils.setScrollHeight(scrollHeight, pageYOffset)
      } else if (readMore) {
        // 次ページ
        url = this.$store.getters.reportListNextPageLink
        clear = false
        loadparams = 'block'
      } else {
        // 通常
        for (var k in this.sortStateInit) {
          this.sortState[k].state = this.sortStateInit[k].state
          this.sortState[k].order = this.sortStateInit[k].order
        }
        this.searchCallbackFlag = false
      }

      var prescribeDate = null
      if (utils.isPresent(this.prescribeDate)) {
        if (utils.isWareki(this.$t, this.prescribeDate)) {
          prescribeDate = utils.wareki2Seireki(this.$t, this.prescribeDate, 'ymd')
        }
      }
      var deliveryDate = null
      if (utils.isPresent(this.deliveryDate)) {
        if (utils.isWareki(this.$t, this.deliveryDate)) {
          deliveryDate = utils.wareki2Seireki(this.$t, this.deliveryDate, 'ymd')
        }
      }
      this.facilityId = this.$router.currentRoute.params['facilityId']
      this.patientId  = this.$router.currentRoute.params['patientId']
      var data = {
        'shop_id':          this.shopId,
        'patient_id':       this.patientId,
        // 'facility_id':      this.facilityId,
        'shop_id':          this.shopId,
        'prescribe_date':   prescribeDate,
        'delivery_date':    deliveryDate,
        'order':            this.orderByString(),
        'orderByStoreData': this.orderByStoreData(),
        'ggPrescribeDate':  this.prescribeDate,
        'ggFeliveryDate':   this.deliveryDate,
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }

      var callback = function () {
        self.searchCallbackFlag = true
      }

      this.$store.dispatch('REPORT_LIST_SEARCH', {url: url, clear: clear, data: data, loadparams: loadparams, callback: callback})
    },
    /** 患者検索遷移 */
    goPatientsList: function() {
      this.$router.push({ path: '/patients/list', query: {'keep': 'true'}})
    },
    /** 計画書詳細遷移 */
    goReportDetail: function(reportId) {
      this.$router.push({ path: '/reports/detail/' + this.facilityId + '/' + this.patientId + '/' + reportId})
    },
    /** PDF出力ボタン */
    onClickPdf: function(reportId) {
      var data = { 'report_id': reportId, 'pdf_header': 1 }
      var self = this
      var callback = function (data) {
        var link = document.getElementById('print_download_link')
        link.setAttribute('download', data.url)
        link.href = data.url
        link.click()
        // ファイル削除
        self.$store.dispatch('REPORT_REMOVE_PDF', {data:{download_id: data.download_id}, callback: (data) => {}, loadparams: 'block'})
      }
      this.$store.dispatch('REPORT_PDF', {data: data, callback: callback, loadparams: 'block'})
    },
    /** 画像押下 */
    onClickImageModalShow: function () {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = this.patient.attributes['avartar-path'] + '?token=' + this.authToken
      text.textContent = ''
      button.click()
    },
    clearSearchParams: function() {
      if (this.$store.getters.canManage && this.shopId === null) {
        this.shopId = this.$store.getters.currentShopId
      }
      this.prescribeDate = null
      this.deliveryDate = null
      this.$store.dispatch('REPORT_LIST_SEARCH_CLEAR')
    },
    sortBy: function(key) {
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order

      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          result.push(key + ' ' + asc_desc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('delivery_date desc')
      }
      return result.join(' , ')
    },
    /** ストアに保存するソート取得 */
    orderByStoreData: function() {
      var key = null
      var state = null
      var order = null
      for (var k in this.sortState) {
        if (this.sortState[k].state) {
          key = k
          order = false
          if (this.sortState[k].order) {
            order = true
          }
        }
      }
      if (key === null) {
        // 存在しない場合
        key = 'delivery_date'
        order = false
      }
      return {key: key, order: order}
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/patient-list-report.js